/* ==========================================================================
   Dynoforce animaties
   Scroll-reveal: elementen met .rv faden omhoog zodra ze in beeld komen.
   Bij prefers-reduced-motion springt alles direct naar de eindstand en komt
   er geen observer aan te pas.
   ========================================================================== */

(function () {
  'use strict';

  var reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var items = document.querySelectorAll('.rv');
  if (!items.length) return;

  if (reduced || !('IntersectionObserver' in window)) {
    items.forEach(function (el) { el.classList.add('in'); });
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('in');
      io.unobserve(e.target);
    });
  }, { threshold: 0.12 });

  items.forEach(function (el) { io.observe(el); });

  /* Secties die de theme editor opnieuw inlaadt ook meenemen. */
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.rv').forEach(function (el) {
      if (reduced) { el.classList.add('in'); } else { io.observe(el); }
    });
  });
})();
